module.exports = __webpack_public_path__ + "fonts/montserrat-regular.6133d7c8.ttf";